import { RootState } from 'src/state/rootReducer';

export const getCompaniesData = (state: RootState) => {
  return state.entities.companies;
};
